import { getCustomerPendings } from "api/Customers";
import { useQuery } from "react-query";




export const useCustomerPendings = (id: number) => {
    const queryInfo = useQuery(
        ['customerPendings'],
        () => getCustomerPendings({ costumer_id: id }),
        {
            onError: (err) => {
                console.error(err);
            },

        }
    );

    return queryInfo;
};